import React, { useState } from 'react'

import { CameraIcon } from '@toasttab/buffet-pui-icons'

import { ButtonType } from 'src/apollo/sites'

import { Button } from 'shared/components/common/button'
import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay
} from 'shared/components/common/modal'
import { t } from 'src/translations'

export type DeliveryPhotoButtonProps = {
  deliveryImageUrl: string
  buttonTestId?: string
  modalTestId?: string
}

const DeliveryPhotoButton = ({
  deliveryImageUrl,
  buttonTestId = 'delivery-photo-button',
  modalTestId = 'delivery-photo-modal'
}: DeliveryPhotoButtonProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className='deliveryPhotoButton'>
      <Button
        variant={ButtonType.Text}
        onClick={() => setIsOpen(true)}
        className='buttonColor padding0 fontWeight400'
        icon={
          <CameraIcon
            accessibility='decorative'
            className='buttonColor paddingTop025'
          />
        }
        data-testid={buttonTestId}
      >
        {t('delivery-photo-button.see-delivery-image')}
      </Button>
      <Modal
        className='deliveryPhotoModal'
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        testId={modalTestId}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <img
            className='deliveryPhoto'
            src={deliveryImageUrl}
            alt={t('delivery-photo-button.delivery-photo')}
          />
        </ModalContent>
      </Modal>
    </div>
  )
}

export default DeliveryPhotoButton
